import { BaseModel, SearchParameter } from './base.model';
import { User } from './user.model';
import { UserPost } from './user-post.model';

export class Like extends BaseModel {
  id?: string;
  user?: User;
  userPost?: UserPost;
}